export const uk = {
    'autobudget-label': 'Приоритет автобюджета',
    cancel: 'Отменить',
    update: 'Изменить'
};
